export const unitConventions = [
  {
    name: 'Units',
    value: 'units'
  },
  {
    name: 'Cycles',
    value: 'cycles'
  },
  {
    name: 'Follicular Unit Excision (FUE)',
    value: 'fue'
  },
  {
    name: 'Lines',
    value: 'lines'
  },
  {
    name: 'Quantity',
    value: 'quantity'
  },
  {
    name: 'Syringes',
    value: 'syringes'
  },
];

export const calculateDiscountValueField = (optionType, editablePrice, discountPrice) => {
  if (optionType === 'percent') {
    return `$${(editablePrice * discountPrice / 100).toFixed(2)}`;
  }

  return `${editablePrice !== 0 ? (discountPrice * 100 / editablePrice).toFixed(2) : 0}%`;
};
